
import { getIcon } from 'material-file-icons';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export default class UtilsModule {
    constructor(){
  
    }

    parseHtml(input){
        let doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    formatColOutput(record, type, icon = true){
        let outputString = record.display ? record.display : '';
        if (type == 'ext' && icon){
            outputString = getIcon(outputString ? "placeholder."+outputString : '' ).svg
        }

        return unsafeHTML(outputString);
    }

    unsafeOutput(val){
        return unsafeHTML(val);
    }

    addSpinner(selector){
        this.removeSpinner(selector)
        let spinnerContainer = document.querySelector('.'+selector);
        if(spinnerContainer){
            let sp = document.createElement("div");
            sp.classList.add('swlri-file-manager-spinner-overlay');
            sp.innerHTML = `<span class='swlri-file-manager-spinner'></span>`;
            spinnerContainer.appendChild(sp);
        }
    }

    removeSpinner(selector){
        let spinnerContainer = document.querySelector('.'+selector);
        if(spinnerContainer){
            spinnerContainer.querySelector('.swlri-file-manager-spinner-overlay')?.remove();
        }
    }

    freezeInterface(freeze, selector){
        // .swlri-file-manager-filelist-files-container
        if(freeze){
            this.addSpinner(selector);
        } else this.removeSpinner(selector)
        var customEv = new CustomEvent("swlri-freeze",{detail:{freeze:freeze}})
        window.dispatchEvent(customEv);
    }

    joinDate(date) {
        const options = [{day: 'numeric'}, {month: 'short'}, {year: 'numeric'}];
        function format(option) {
           let formatter = new Intl.DateTimeFormat('en', option);
           return formatter.format(date);
        }
        return options.map(format).join(" ");
    }
}